<script>
    
    import {filterStore, rangesStore, filterPosts, filterHash} from '../stores.js';
    import Columns from './Columns.svelte';
    import Post from './Post.svelte';

    export let posts = [];
    let visible = posts;
    let visibleIdsHash = '';

    let lastFilter = '';
    function filter(){
        let newFilter = filterHash( $filterStore, $rangesStore );
        if( newFilter === lastFilter ){
            console.log('filter has not changed');
            return;
        }
        lastFilter = newFilter;
        let results = filterPosts( posts, $filterStore, $rangesStore );
        let newVisibleIdsHash = JSON.stringify( results.map(post => post.id) );
        if( newVisibleIdsHash !== visibleIdsHash ){
            visible = results;
            visibleIdsHash = newVisibleIdsHash;
        }
    }
    $: filter( $filterStore, $rangesStore );


</script>

{#if visible.length > 0}
    <Columns items={visible} let:prop={post}>
        <Post {post} />
    </Columns>
{/if}

<style>
</style>